import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'

import { ModalConfirm } from 'mailup-web-components'

import { modalDeleteConfirmCallback } from '../recoil/callbacks/callbacks'
import { modalDeleteState } from '../recoil/state/modals'

const ModalDelete = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalDeleteState)

  const handleConfirm = useRecoilCallback(modalDeleteConfirmCallback, [])

  const handleCancel = useResetRecoilState(modalDeleteState)

  return (
    <ModalConfirm
      data-mu-test='modal-template-delete'
      show={show}
      showClose={false}
      closeOnOverlayClick={false}
      title={intl.formatMessage({ id: 'Load.Bee.ModalTitleForDeleteTemplate' })}
      message={intl.formatMessage({
        id: 'Load.Bee.ModalDescriptionForDeleteTemplate'
      })}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Yes' })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
      onClickConfirm={handleConfirm}
      onClickCancel={handleCancel}
    />
  )
}

export default ModalDelete
